import { useTranslation } from 'react-i18next'
import { Await, Link, useLoaderData } from 'react-router-dom'
import { PageLayout } from '@/layouts/page-layout'
import { CreateButton } from '@/shared/components/action-buttons'
import { create } from '@/router/utils'
import { HasAccess } from '@permify/react-role'
import { useAuthorization } from '@/hooks'
import { Suspense, useEffect } from 'react'
import { PageLayoutError, PageLayoutOverlay } from '@/layouts'
import { OfficeTable } from './tables'
import { OfficesFilter } from '@/components/offices-filter'

export const OfficeList = () => {
  const { hasAccess } = useAuthorization({
    redirection: {
      enable: true
    }
  })

  const { promise } = useLoaderData()
  const { t } = useTranslation()

  useEffect(() => {
    hasAccess('office#list')
  }, [])

  return (
    <PageLayout
      title={t('office.other')}
      actions={
        <div key='asset-action-buttons' className='flex gap gap-3'>
          <OfficesFilter/>
          <HasAccess permissions={['office#create']}>
            <Link key='new_office' to={create('offices')}>
              <CreateButton />
            </Link>
          </HasAccess >
        </div>
      }
    >
      <Suspense fallback={<PageLayoutOverlay />}>
        <Await resolve={promise} errorElement=<PageLayoutError message='No se pudieron cargar las dependencias' />>
          <OfficeTable />
        </Await>
      </Suspense>
    </PageLayout>
  )
}
